// Remembers that a visitor has already requested the fall maintenance
// checklist, so a repeat visit shows the confirmation above the form instead
// of an empty field.
//
// The checklist is delivered by email only — the PDF is deliberately never
// hosted on this site — so there is nothing to link a returning visitor to.
// The form is left usable on purpose: submitting again is the only way to ask
// for another copy.

const FORM_ID = '7';
const STORAGE_KEY = 'am-guide-requested-7';
const NOTICE_TEXT = 'Check your inbox — your free roof maintenance checklist is on its way.';

// Storage throws in private windows and when site data is blocked, so every
// access is guarded and the form simply behaves as it does for a new visitor.
const hasRequested = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

const rememberRequest = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch (error) {
    // Nothing to do — the notice just won't persist for this visitor.
  }
};

const showNotice = (wrapper) => {
  if (wrapper.querySelector('.guide-notice')) return;

  const notice = document.createElement('p');
  notice.className = 'guide-notice';
  notice.setAttribute('role', 'status');
  notice.textContent = NOTICE_TEXT;

  wrapper.insertBefore(notice, wrapper.firstChild);
};

const guideForm = () => {
  // Matches both placements of form 7 — the Fall Season hero and the guide
  // download panel in the blog sidebar.
  const wrappers = document.querySelectorAll(`[id^="gform_wrapper_${FORM_ID}"]`);
  if (!wrappers.length) return;

  if (hasRequested()) {
    wrappers.forEach(showNotice);
  }

  // Gravity Forms fires this on its jQuery bus when an AJAX confirmation
  // renders, which is the only reliable signal that a submission succeeded.
  if (window.jQuery) {
    window.jQuery(document).on('gform_confirmation_loaded', (event, formId) => {
      if (String(formId) === FORM_ID) {
        rememberRequest();
      }
    });
  }
};

export { guideForm };
